import angular from "angular";

import ServiceRA from "app/services/ServiceRA";
import AuthenticationService from "./AuthenticationService";
import FeatureService from "./FeatureService";
import toastr from "app/services/toastr";
import shajs from "app/services/sha";
import LocaleService from "app/services/LocaleService.js";

export default angular.module("services.UserService", [shajs, LocaleService, toastr, ServiceRA, AuthenticationService, FeatureService]).factory("UserService",
  ["shajs", "LocaleService", "toastr", "$http", "$q", "$state", "$log", "$rootScope", "ServiceRA", "AuthenticationService", "FeatureService", "Utils",
    function UserService(shajs, LocaleService, toastr, $http, $q, $state, $log, $rootScope, ServiceRA, AuthenticationService, FeatureService, Utils) {

      var fieldsController;

      var abortGet = {
        "getUser": $q.defer(),
        "getUserToken": $q.defer(),
        "getUsers": $q.defer(),
        "getRole": $q.defer(),
        "getRoles": $q.defer(),
        "getEmails": $q.defer(),
        "getEmail": $q.defer(),
        "getActivities": $q.defer(),
        "getPhonenumbers": $q.defer(),
        "fetchKycCaptures": $q.defer(),
      };

      var userFields = [
        {
          i18nKey: "userAdministration.overview.columns.name",
          field: (item) => item.lastName + " " + item.firstName,
          sortField: "lastName+firstName",
          defaultSorting: "asc",
          type: "text", // [text | number | money | date | custom]
          class: "col-xs-3",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => true,
          shouldShow: (key, value) => true,
          filter: {
            type: "text",
            placeholderI18nKey: "filter.placeholder.username",
            field: "$q",
            extension: {
              "$qf": ["firstName", "lastName", "username", "email", "phoneNumbers.id"]
            },
            shouldShow: (key, value) => true
          }
        },
        {
          i18nKey: "userAdministration.overview.columns.role",
          field: (item) => item.visibleRoles,
          type: "text", // [text | number | money | date | custom]
          class: "col-xs-2",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => !fieldsController.isConAdmin(),
          shouldShow: (key, value) => true
        },
        {
          i18nKey: "userAdministration.overview.columns.customerId",
          field: (item) => item.customerId,
          format: "0",
          sortField: "customerId",
          type: "number", // [text | number | money | date | custom]
          class: "col-xs-2",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => fieldsController.isConAdmin(),
          shouldShow: (key, value) => true,
          filter: {
            type: "number",
            field: "customerId",
            shouldShow: (key, value) => true
          }
        },
        {
          i18nKey: "userAdministration.overview.columns.createdAt",
          field: (item) => item.createdAt,
          tooltip: (item) => LocaleService.formatDate(item.createdAt, "shortDateTime"),
          sortField: "createdAt",
          type: "date", // [text | number | money | date | custom]
          format: "shortDate",
          class: "col-xs-2",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => true
        },
        {
          i18nKey: "userAdministration.overview.columns.lastLogin",
          field: (item) => item.lastLogin,
          tooltip: (item) => LocaleService.formatDate(item.lastLogin, "shortDateTime"),
          sortField: "lastLogin",
          type: "date", // [text | number | money | date | custom]
          format: "shortDate",
          class: "col-xs-2",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => true
        },
        {
          i18nKey: "userAdministration.overview.columns.blocked",
          field: (item) => "blocked",
          tooltipI18nKey: (item) => {
            return item.blocked ? 'user.tooltip.blocked' : 'user.tooltip.notBlocked';
          },
          type: "checkbox", // [text | number | money | date | custom]
          class: "col-xs-1",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => true,
          shouldShow: (key, value) => true,
          shouldShowItem: (field, item) => item.edit,
          onClick: (item) => fieldsController.blockUnblockUser(item)
        },
        {
          i18nKey: "userSettings.list.switchUser",
          tooltipI18nKey: "userSettings.tooltip.switchUser",
          type: "icon",
          iconClass: "fa fa-exchange",
          style: { width: "1%" },
          onClick: (item) => fieldsController.switchUser(item),
          shouldShowItem: (field, item) => item.edit,
          shouldShowColumn: (field) => true
        },
        {
          i18nKey: "userSettings.list.editUser",
          tooltipI18nKey: "userSettings.tooltip.editUser",
          type: "icon",
          iconClass: "fa fa-pencil",
          style: { width: "1%" },
          onClick: (item) => fieldsController.editUser(item),
          shouldShowItem: (field, item) => item.edit,
          shouldShowColumn: (field) => true
        },
        {
          i18nKey: "userSettings.list.deleteUser",
          tooltipI18nKey: "userSettings.tooltip.deleteUser",
          type: "icon",
          iconClass: "fa fa-trash-o",
          style: { width: "1%" },
          onClick: (item) => fieldsController.deleteUser(item),
          refreshAfterClick: () => true,
          shouldShowItem: (field, item) => item.edit,
          shouldShowColumn: (field) => true
        }
      ];

      var roleFields = [
        {
          i18nKey: "roleDetail.profile.rolename",
          field: (item) => item.username,
          sortField: "username",
          defaultSorting: "asc",
          type: "text", // [text | number | money | date | custom]
          class: "col-xs-7",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => true,
          shouldShow: (key, value) => true,
          filter: {
            type: "text", //[text | number | money | date ]
            field: "username",
            shouldShow: (key, value) => true
          }
        },
        {
          i18nKey: "roleAdministration.overview.columns.createdAt",
          field: (item) => item.createdAt,
          sortField: "createdAt",
          type: "date", // [text | number | money | date | custom]
          format: "shortDate",
          class: "col-xs-2",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => true
        },
        {
          i18nKey: "roleAdministration.overview.columns.lastLogin",
          field: (item) => item.lastLogin,
          sortField: "lastLogin",
          type: "date", // [text | number | money | date | custom]
          format: "shortDate",
          class: "col-xs-2",
          headerClass: "sort-align-right col-xs-1",
          shouldShowColumn: (field) => true
        }, {
          i18nKey: "roleAdministration.overview.columns.actions",
          tooltipI18nKey: "roleAdministration.tooltip.edit",
          type: "icon",
          iconClass: "fa fa-pencil",
          style: { width: "1%" },
          onClick: (item) => fieldsController.editRole(item),
          shouldShowColumn: (field) => true,
        }, {
          i18nKey: "roleAdministration.overview.columns.actions",
          tooltipI18nKey: "roleAdministration.tooltip.delete",
          type: "icon",
          iconClass: "fa fa-trash-o",
          style: { width: "1%" },
          onClick: (item) => fieldsController.deleteRole(item),
          refreshAfterClick: () => true,
          shouldShowColumn: (field) => true,
        }
      ];

      function getUser(id) {
        //    console.log("getUser id: ", id);

        if (abortGet["getUser" + id]) {
          abortGet["getUser" + id].promise.isGloballyCanceled = true;
          abortGet["getUser" + id].resolve();
        }
        abortGet["getUser" + id] = $q.defer();

        return ServiceRA.one("users", id).withHttpConfig({
          timeout: abortGet["getUser" + id].promise
        }).get();
      }

      function getUserToken(token) {
        //console.log("getUser token: ", token);

        if (abortGet["getUserToken"]) {
          abortGet["getUserToken"].promise.isGloballyCanceled = true;
          abortGet["getUserToken"].resolve();
        }
        abortGet["getUserToken"] = $q.defer();

        return ServiceRA.one("users").one("token", token).withHttpConfig({
          timeout: abortGet["getUserToken"].promise
        }).get();
      }

      function getUsers(_qo) {
        if (abortGet["getUsers"]) {
          abortGet["getUsers"].promise.isGloballyCanceled = true;
          abortGet["getUsers"].resolve();
        }
        abortGet["getUsers"] = $q.defer();

        var qo = _qo || {
          filter: {}
        };
        qo = Utils.prepareFilter(qo);

        /*var includedIssuers = ConfigService.get("includedIssuers.roles", true);
        if (includedIssuers) {
          qo.filter.issuer = includedIssuers;
        }*/
        var headers = Utils.prepareHeaders("getUsers");

        return ServiceRA.all("users").withHttpConfig({
          timeout: abortGet["getUsers"].promise
        }).getList(qo.filter, headers);
      }

      function deleteUser(_id) {
        return updateUser(_id, {
          active: false
        }, "deleteUser");
      }

      function deleteRole(_id) {
        return updateRole(_id, {
          active: false
        }, "deleteRole");
      }

      function updateUser(_id, user, action) {
        var defer = $q.defer();
        var userToUpdate = _.pick(user, ["title", "firstName", "lastName", "phone", "salutation", "sendNotifications", "blocked", "active", "updatedPermissions", "isFirstLogin", "userObjectsRead", "userObjectsWrite", "userObjectsCreate", "changeNotificationSettings"]);
        var headers = Utils.prepareHeaders(action);
        ServiceRA.one("users", _id).customPUT(userToUpdate, null, null, headers).then(function (response) {

          var roleIds = _.map(user.roles, "_id");

          AuthenticationService.getUser().then(function (myUser) {
            if (myUser._id !== response._id) {
              if (roleIds) {
                ServiceRA.one("users", _id).one("roles").customPUT(roleIds, null, null, headers).then(function (roleResponse) {
                  defer.resolve(response);
                }, function (err) {
                  $log.error(err);
                  defer.reject(err);
                });
              }
              else {
                defer.resolve(response);
              }
            }
            else {
              defer.resolve(response);
            }
          }, function (err) {
            $log.error(err);
            defer.reject(err);
          });
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function updateUserEmail(_id, user, action) {
        var defer = $q.defer();
        var userToUpdate = _.pick(user, ["email", "showEmailDialog"]);
        var headers = Utils.prepareHeaders(action);
        ServiceRA.one("users", _id).customPUT(userToUpdate, null, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function updateUserVerifications(_id, user, action) {
        var defer = $q.defer();
        var userToUpdate = _.pick(user, ["contractsToVerify"]);
        userToUpdate.oldContractsToVerify = user.oldContractsToVerify;
        var headers = Utils.prepareHeaders(action);
        ServiceRA.one("users", _id).customPUT(userToUpdate, null, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function updateRole(_id, role, action) {
        var defer = $q.defer();
        var roleToUpdate = _.pick(role, ["username", "blocked", "active", "updatedPermissions", "userObjectsRead", "userObjectsWrite", "userObjectsCreate", "changeNotificationSettings"]);
        var headers = Utils.prepareHeaders(action);
        ServiceRA.one("roles", _id).customPUT(roleToUpdate, null, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function registerRole(role) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("registerRole");
        role.context = AuthenticationService.getContext();
        ServiceRA.all("roles").post(role, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          Utils.handleError(err, LocaleService.get("settingsRoleEdit.errors.save"));
          defer.reject(err);
        });
        return defer.promise;
      }

      function getRoles(_qo) {
        if (abortGet["getRoles"]) {
          abortGet["getRoles"].promise.isGloballyCanceled = true;
          abortGet["getRoles"].resolve();
        }
        abortGet["getRoles"] = $q.defer();

        var qo = _qo || {
          filter: {
            active: true
          }
        };
        qo.filter = _.assign(qo.filter, { "edit": true });
        qo = Utils.prepareFilter(qo);

        /*var includedIssuers = ConfigService.get("includedIssuers.roles", true);
        if (includedIssuers) {
          qo.filter.issuer = includedIssuers;
        }*/

        var headers = Utils.prepareHeaders("getRoles");

        return ServiceRA.all("roles").withHttpConfig({
          timeout: abortGet["getRoles"].promise
        }).getList(qo.filter, headers);
      }

      function getRole(id) {

        if (abortGet["getRole"]) {
          abortGet["getRole"].promise.isGloballyCanceled = true;
          abortGet["getRole"].resolve();
        }
        abortGet["getRole"] = $q.defer();

        return ServiceRA.one("roles", id).withHttpConfig({
          timeout: abortGet["getRole"].promise
        }).get();
      }

      function switchUser(user) {
        var headers = Utils.prepareHeaders("switchUser");
        return ServiceRA.all("users").one("changeTo", user._id).put({}, headers).then((user) => {
          AuthenticationService.setUser(user);
          return $q.when(user);
        });
      }

      function cancelSwitchedUser() {
        var headers = Utils.prepareHeaders("cancelSwitchUser");
        return ServiceRA.all("users").one("changeTo", "me").put({}, headers).then((user) => {
          AuthenticationService.setUser(user);
          return $q.when(user);
        });
      }

      function requestPassword(email) {

        var defer = $q.defer();

        var headers = Utils.prepareHeaders("requestPassword");
        ServiceRA.all("requestPassword").post({
          email: email,
          context: AuthenticationService.getContext()
        }, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          defer.reject(err);
        });

        return defer.promise;
      }

      function resetPassword(password, password2, token, email) {

        var defer = $q.defer();
        ServiceRA.all("resetPassword").post({
          password: password,
          password2: password2,
          token: token,
          email: email
        }, null, {
          "dcb-frontend-action": "resetPassword"
        }).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          defer.reject(err);
        });

        return defer.promise;
      }

      function registerUser(user) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("registerUser");
        user.isFirstLogin = true;
        ServiceRA.all("register").post(user, null, headers).then(function (response) {

          var roleIds = _.map(user.roles, "_id");
          if (roleIds) {
            ServiceRA.one("users", response._id).one("roles").customPUT(roleIds, null, null, headers).then(function (roleResponse) {
              defer.resolve(response);
            }, function (err) {
              $log.error(err);
              defer.reject(err);
            });
          }
          else {
            defer.resolve(response);
          }

        }, function (err) {
          defer.reject(err);
        });

        return defer.promise;
      }

      function completeRegistration(user, token) {
        var defer = $q.defer();
        var data = user;
        data.token = token;
        var headers = Utils.prepareHeaders("completeRegistration");
        ServiceRA.all("completeRegistration").post(data, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          Utils.handleError(err, LocaleService.get("signupdone.errors.registration"));
          defer.reject(err);
        });
        return defer.promise;
      }

      function getRegistrationDetails(token) {
        var defer = $q.defer();
        ServiceRA.one("usersByRegistrationToken").get({
          $token: token
        }).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          Utils.handleError(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function getSignupDetails(token) {
        var defer = $q.defer();
        ServiceRA.one("usersBySignupToken").get({
          $token: token
        }).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          Utils.handleError(err, LocaleService.get("changeEmail.info.error.default"));
          defer.reject(err);
        });
        return defer.promise;
      }

      function getResetPasswordUserDetails(token) {
        var defer = $q.defer();
        ServiceRA.one("usersByResetPasswordToken").get({
          $token: token
        }).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          Utils.handleError(err, LocaleService.get("resetPassword.error"));
          defer.reject(err);
        });
        return defer.promise;
      }

      function signupUser(user) {
        var defer = $q.defer();

        var headers = Utils.prepareHeaders("signup");

        ServiceRA.all("signup").post({
          card: shajs("sha256").update(user.cardnumber).digest("hex"),
          //card: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday),
          email: user.newEmail,
          password: user.newPassword,
          context: AuthenticationService.getContext()
        }, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          defer.reject(err);
        });

        return defer.promise;
      }

      function identificationSignupUser(user, verificationContext) {
        var defer = $q.defer();

        var headers = Utils.prepareHeaders("identificationSignup");
        let identificationSignupBody = {
          code: user.code,
          cardNr: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday),
          email: user.newEmail,
          password: user.newPassword,
          context: AuthenticationService.getContext()
        };
        if (verificationContext) {
          identificationSignupBody.verificationContext = verificationContext;
        }
        ServiceRA.all("identificationSignup").post(identificationSignupBody, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          defer.reject(err);
        });

        return defer.promise;
      }

      function verifyCustomer(user) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("verifyCustomer");

        ServiceRA.all("verifyCustomer").post({
          code: user.code,
          cardNr: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday)
        }, null, headers).then((response) => {
          defer.resolve(response);
        }, (err) => {
          defer.reject(err);
        });
        return defer.promise;
      }

      function getAnonymousProtectBuyData(user) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("getAnonymousProtectBuyData");

        ServiceRA.all("getAnonymousProtectBuyData").post({
          code: user.code,
          cardNr: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday)
        }, null, headers).then((response) => {
          defer.resolve(response);
        }, (err) => {
          defer.reject(err);
        });
        return defer.promise;
      }

      function convertAuth(auth) {
        return {
          code: auth.code,
          cardNr: auth.cardnumber,
          cvv: auth.cardcvv,
          birthday: Utils.getDateField(auth.birthday),
        };
      }

      function fetchKycModel() {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("fetchKycModel");

        ServiceRA.all("fetchKycModel")
          .post({"type": "kycRegistration"}, null, headers) //TODO: WEB-4062 - change to get
          .then(
            (success) => { defer.resolve(success); },
            (failure) => { defer.reject(failure); }
          );

        return defer.promise;
      }

      function getAnonymousKycData(auth) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("getAnonymousKycData");

        ServiceRA.all("getAnonymousKycData")
          .post(convertAuth(auth), null, headers)
          .then(
            (success) => { defer.resolve(success); }, 
            (failure) => { defer.reject(failure); }
          );

          return defer.promise;
      }

      function updateKycData(auth, user, step, raiseError) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("updateKycData");

        if (raiseError) {
          defer.reject("notallowed");
        } else {
          ServiceRA.all("updateKycData")
            .post(
              { customer: user, step: step, auth: convertAuth(auth) },
              null,
              headers
            )
            .then(
              (success) => {
                defer.resolve(success);
              },
              (failure) => {
                defer.reject(failure);
              }
            );
        }

        return defer.promise;
      }

      function completeKycData(auth, user, files) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("completeKycData");
        
        ServiceRA.all("completeKycData")
        .post({"customer": user, "auth": convertAuth(auth), "files": files}, null, headers)
        .then(
          (success) => { defer.resolve(success); },
          (failure) => { defer.reject(failure); }
        );

        return defer.promise;
      }

      function changeKycCaptureStatus(kycChangeObjects, targetStatus, closeReason) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("changeKycCaptureStatus");
        let allOk = true;

        ServiceRA.all("changeKycCaptureStatus")
          .post({ kycChangeObjects: kycChangeObjects, status: targetStatus, closeReason: closeReason }, null, headers)
          .then(
            (success) => {
              if (success.length) {
                for (let i = 0; i < success.length; i++) {
                  allOk = allOk && (success[i].errno === undefined);
                  // Not wanted: Show toastr for every Successful or erroneous State Change
                  // if (!(success[i].errno === undefined)) {
                  //   toastr.warning(LocaleService.get("kyc.admin.changeStatus.error"));
                  // } else {
                  //   toastr.success(LocaleService.get("kyc.admin.changeStatus.success"));
                  // }
                }
                if (allOk) {
                  defer.resolve(success);
                } else {
                  defer.reject(success);
                }
              } else {
                defer.resolve(success);
              }
            },
            (failure) => {
              defer.reject(failure);
            }
          );

        return defer.promise;
      }

      function confirmAdvertising(user) {
        var defer = $q.defer();

        var headers = Utils.prepareHeaders("confirmAdvertising");

        ServiceRA.all("confirmAdvertising").post({
          code: user.code,
          cardNr: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday),
          email: user.email || false,
          mobile: user.mobile || false,
          phone: user.phone || false,
          confirmed: true
        }, null, headers).then((response) => {
          defer.resolve(response);
        }, (err) => {
          defer.reject(err);
        });
        return defer.promise;
      }

      function verifyNewsletter(usercode, doActivate) {
        var defer = $q.defer();

        var headers = Utils.prepareHeaders("verifyNewsletter");

        ServiceRA.all("verifyNewsletter").post({
          code: usercode,
          activate: doActivate
        }, null, headers).then((response) => {
          defer.resolve(response);
        }, (err) => {
          defer.reject(err);
        });
        return defer.promise;
      }

      function confirmIdentity(user) {
        var defer = $q.defer();

        var headers = Utils.prepareHeaders("confirmIdentity");

        ServiceRA.all("confirmIdentity").post({
          code: user.code,
          cardNr: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday),
          customerPassword: user.customerPassword,
          question1: user.question1,
          question2: user.question2,
          question3: user.question3,
          answer1: user.answer1,
          answer2: user.answer2,
          answer3: user.answer3
        }, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          defer.reject(err);
        });

        return defer.promise;
      }

      function completeSignup(userdetails) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("completeSignup");
        ServiceRA.all("completeSignup").post(userdetails, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          if (_.get(err, "data.error.parameters.name") === "InvalidPhoneNumber") {
            if (_.get(userdetails, "phoneBusiness") || _.get(userdetails, "phoneBusiness")) {
              toastr.warning(LocaleService.get("completeSignupPage.errors.invalidPhoneNumber"));
            }
            $state.go("login", {});
          }
          else {
            toastr.error(LocaleService.get("completeSignupPage.errors.invalidData"));
            $log.error(err);
            defer.reject(err);
          }
        });
        return defer.promise;
      }

      function changePassword(newPassword, oldPassword) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("changePassword");

        AuthenticationService.getUser().then(function (user) {

          ServiceRA.one("users", user._id).one("changePassword").customPUT({
            password: newPassword,
            oldPassword: oldPassword
          }, "", null, headers).then(function (response) {
            defer.resolve(response);
          }, function (err) {
            $log.error(err);
            defer.reject(err);
          });

        }, defer.reject);

        return defer.promise;
      }

      function getEmail(cardDetails) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("requestEmail");

        if (abortGet["getEmail"]) {
          abortGet["getEmail"].promise.isGloballyCanceled = true;
          abortGet["getEmail"].resolve();
        }
        abortGet["getEmail"] = $q.defer();

        ServiceRA.all("requestEmail").withHttpConfig({
          timeout: abortGet["getEmail"].promise
        }).post({
          card: shajs("sha256").update(cardDetails.cardnumber).digest("hex"),
          //card: cardDetails.cardnumber,
          cvv: cardDetails.cardcvv,
          birthday: Utils.getDateField(cardDetails.birthday),
          context: AuthenticationService.getContext()
        }, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          defer.reject(err);
        });

        return defer.promise;
      }

      function getEmails(_qo) {
        if (abortGet["getEmails"]) {
          abortGet["getEmails"].promise.isGloballyCanceled = true;
          abortGet["getEmails"].resolve();
        }
        abortGet["getEmails"] = $q.defer();

        var qo = _qo || {
          filter: {}
        };

        var regexpFields = ["to", "subject", "template"];
        var dateFields = ["createdAtFrom", "createdAtUntil", "sentAtFrom", "sentAtUntil"]; // ["displayValidFrom", "displayValidUntil"];

        qo = Utils.prepareFilter(qo, regexpFields, dateFields);

        return ServiceRA.all("emails").withHttpConfig({
          timeout: abortGet["getEmails"].promise
        }).getList(qo.filter);
      }

      function getActivities(_qo) {
        if (abortGet["getActivities"]) {
          abortGet["getActivities"].promise.isGloballyCanceled = true;
          abortGet["getActivities"].resolve();
        }
        abortGet["getActivities"] = $q.defer();

        var qo = _qo || {
          filter: {}
        };

        var regexpFields = ["name", "user.email", "userFor.email",];
        var dateFields = ["dateFrom", "dateUntil"]; // ["displayValidFrom", "displayValidUntil"];

        qo = Utils.prepareFilter(qo, regexpFields, dateFields);

        return ServiceRA.all("userActivities").withHttpConfig({
          timeout: abortGet["getActivities"].promise
        }).getList(qo.filter);
      }

      function fetchKycCaptures(_qo, searchFields = [""], dateFields = [""]) {
        var qo = _qo || { filter: {} };
        if (abortGet["fetchKycCaptures"]) {
          abortGet["fetchKycCaptures"].promise.isGloballyCanceled = true;
          abortGet["fetchKycCaptures"].resolve();
        }
        abortGet["fetchKycCaptures"] = $q.defer();

        qo = Utils.prepareFilter(qo, searchFields, dateFields);

        return ServiceRA.all("kycCaptures")
          .withHttpConfig({
            timeout: abortGet["fetchKycCaptures"].promise,
          })
          .getList(qo.filter);
      }

      function fetchKycCaptureData(kycCaptureId) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("fetchKycCaptureData");
        
        ServiceRA.all("fetchKycCaptureData")
        .get(kycCaptureId, null, headers)
        .then(
          (success) => { defer.resolve(success); },
          (failure) => { defer.reject(failure); }
        );

        return defer.promise;
      }

      function getPhonenumbers(user) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("getPhonenumbers");

        if (abortGet["getPhonenumbers"]) {
          abortGet["getPhonenumbers"].promise.isGloballyCanceled = true;
          abortGet["getPhonenumbers"].resolve();
        }
        abortGet["getPhonenumbers"] = $q.defer();

        return ServiceRA.one("users", user._id).one("phoneNumbers").withHttpConfig({
          timeout: abortGet["getPhonenumbers"].promise
        }).get();
      }

      function sendVerificationToPhone(user, phone) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("sendVerification");


        ServiceRA.one("users", user._id).one("phoneNumbers", phone).one("sendVerificationCode").customPUT({
          id: phone
        }, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function sendProtectBuyVerificationToPhone(user, phone, password) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("sendVerification");
        let data = {
          id: phone
        };
        if (password && (password.length > 0)) {
          data.staticProtectBuyPassword = shajs("sha256").update(password).digest("hex");
        }

        ServiceRA.one("users", user._id).one("sendOTPProtectBuy2FA").customPUT(data, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function sendProtectBuyVerificationToPhoneAnonymous(user, phone, password) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("sendAnonymousOTP");

        ServiceRA.all("sendAnonymousOTP").post({
          code: user.code,
          cardNr: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday),
          id: phone,
          staticProtectBuyPassword: shajs("sha256").update(password).digest("hex")
        }, null, headers).then((response) => {
          defer.resolve(response);
        }, (err) => {
          defer.reject(err);
        });

        return defer.promise;
      }

      function doVerifyProtectBuy(user, phone, TANcode, password) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("doVerifyProtectBuy");
        let pbdata = {
          id: phone.id,
          verificationCode: TANcode
        };
        if (password && (password.length > 0)) {
          pbdata.staticProtectBuyPassword = shajs("sha256").update(password).digest("hex");
        }

        ServiceRA.one("users", user._id).one("validateOTPProtectBuy2FA").customPUT(pbdata, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function getUserIfEmpty(user) {
        var defer = $q.defer();
        if (!user) {
          AuthenticationService.getUser().then(function (user) {
            defer.resolve(user);
          }).catch(function (err) {
            $log.error(err);
            defer.reject(err);
          });
        }
        else {
          defer.resolve(user);
        }
        return defer.promise;
      }

      function doSendMessengerActivationLink(user, messengertype, phonenumber) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("sendMessengerActvationLink");

        getUserIfEmpty(user).then(function (user) {
          ServiceRA.one("users", user._id).one("messenger").customPOST({
            "messenger": messengertype,
            "phoneNumber": phonenumber
          }).then(function (response) {
            defer.resolve(response);
          }, function (err) {
            $log.error(err);
            defer.reject(err);
          });
        }).catch(function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function doVerifyPhone(user, phone, TANcode) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("verifyPhone");

        ServiceRA.one("users", user._id).one("phoneNumbers", phone.id).one("verifyPhoneNumber").customPUT({
          id: phone.id,
          status: phone.status,
          active: phone.active,
          verificationCode: TANcode
        }, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });

        return defer.promise;
      }

      function doVerifyPhoneAnonymous(user, phone, password, TANcode) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("validateAnonymousOTP");

        ServiceRA.all("validateAnonymousOTP").post({
          code: user.code,
          cardNr: user.cardnumber,
          cvv: user.cardcvv,
          birthday: Utils.getDateField(user.birthday),
          id: phone.id,
          staticProtectBuyPassword: shajs("sha256").update(password).digest("hex"),
          status: phone.status,
          active: phone.active,
          verificationCode: TANcode
        }, null, headers).then((response) => {
          defer.resolve(response);
        }, (err) => {
          defer.reject(err);
        });

        return defer.promise;
      }

      function deactivatePhone(user, phone) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("deactivatePhoneNumber");

        ServiceRA.one("users", user._id).one("phoneNumbers", phone.id).one("deactivatePhoneNumber").customPUT({
          // id: phone.id
        }, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function removePhone(user, phone) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("deletePhoneNumber");

        ServiceRA.one("users", user._id).one("phoneNumbers", phone.id).one("deletePhoneNumber").customPUT({
          id: phone.id
        }, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function changeEmail(id, newEmail) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("startEmailChange");
        ServiceRA.one("users", id).one("changeEmail").customPUT({
          email: newEmail
        }, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function resendEmailVerification(id, pendingEmail) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("resendEmailVerification");
        ServiceRA.one("users", id).one("resendEmailChange").customPUT({
          email: pendingEmail
        }, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function cancelEmailChange(id) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("cancelEmailChange");
        ServiceRA.one("users", id).one("cancelEmailChange").customPUT({}, "", null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function completeEmailChange(token) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("completeEmailChange");
        ServiceRA.one("completeEmailChange").customPOST({
          token: token
        }, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function trackActivity(name, data) {
        var defer = $q.defer();
        ServiceRA.one("userActivities").customPOST({
          name: name,
          data: data
        }, null).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function addContractVerification(token) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("addContractVerification");
        ServiceRA.one("verifyAddContract").customPOST({
          token: token
        }, null, headers).then(function (response) {
          defer.resolve(response);
        }, function (err) {
          $log.error(err);
          defer.reject(err);
        });
        return defer.promise;
      }

      function resendEmail(resendInformation, useId) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("resendEmail");

        getUser(useId).then(function (user) {
          var body = { email: _.get(user.plain(), resendInformation.email) || _.get(user.plain(), "email"), context: user.context || "CON" };

          if (resendInformation.url.indexOf(":useId") > -1) {
            resendInformation.url = resendInformation.url.replace(":useId", useId);
          }

          if (resendInformation.method === "GET") {
            defer.resolve();
          }
          else if (resendInformation.method === "POST") {
            ServiceRA.one(resendInformation.url).customPOST(body, null, headers).then(function (response) {
              toastr.success(LocaleService.get("resendEmail.success.post"));
              defer.resolve(response);
            }, function (err) {
              Utils.handleError(err, LocaleService.get("resendEmail.errors.post"));
              defer.reject(err);
            });
          }

          else if (resendInformation.method === "PUT") {
            ServiceRA.one(resendInformation.url).customPUT(body, null, headers).then(function (response) {
              toastr.success(LocaleService.get("resendEmail.success.put"));
              defer.resolve(response);
            }, function (err) {
              Utils.handleError(err, LocaleService.get("resendEmail.errors.put"));
              defer.reject(err);
            });
          }
        });
        return defer.promise;

      }

      function canReadUsers(user) {
        return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.userObjectsRead;
      }

      function canEditUsers(user) {
        return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.userObjectsWrite;
      }

      function canEditNotifications(user) {
        return user.effectiveUserObjectPermissions && user.effectiveUserObjectPermissions.changeNotificationSettings;
      }

      function canSeeKYC(user) {
        return AuthenticationService.getContext() === "CON_ADMIN";
      }

      function hasSsms(user) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("hasSsms");

        if (abortGet["hasSsms"]) {
          abortGet["hasSsms"].promise.isGloballyCanceled = true;
          abortGet["hasSsms"].resolve();
        }
        abortGet["hasSsms"] = $q.defer();

        return ServiceRA.one("users", user._id).one("hasSecureSms").withHttpConfig({
          timeout: abortGet["hasSsms"].promise
        }).get();
      }

      function hasProtectBuy(user) {
        var defer = $q.defer();
        var headers = Utils.prepareHeaders("hasProtectBuy2FA");

        if (abortGet["hasProtectBuy2FA"]) {
          abortGet["hasProtectBuy2FA"].promise.isGloballyCanceled = true;
          abortGet["hasProtectBuy2FA"].resolve();
        }
        abortGet["hasProtectBuy2FA"] = $q.defer();

        return ServiceRA.one("users", user._id).one("hasProtectBuy2FA").withHttpConfig({
          timeout: abortGet["hasProtectBuy2FA"].promise
        }).get();
      }

      function hasFeature(key) {
        return AuthenticationService.reloadUser().then(function () {
          return FeatureService.hasFeature(key);
        });
      }

      function getRoleFields(ctrl) {
        if (ctrl) {
          fieldsController = ctrl;
        }

        return angular.copy(roleFields);
      }

      function getUserFields(ctrl) {
        if (ctrl) {
          fieldsController = ctrl;
        }

        return angular.copy(userFields);
      }

      return {
        canEditUsers: canEditUsers,
        canReadUsers: canReadUsers,
        canEditNotifications: canEditNotifications,
        canSeeKYC: canSeeKYC,
        updateUser: updateUser,
        updateUserEmail: updateUserEmail,
        updateUserVerifications: updateUserVerifications,
        deleteUser: deleteUser,
        getUsers: getUsers,
        getUser: getUser,
        getUserToken: getUserToken,
        deleteRole: deleteRole,
        updateRole: updateRole,
        registerRole: registerRole,
        getRoles: getRoles,
        getRole: getRole,
        switchUser: switchUser,
        requestPassword: requestPassword,
        cancelSwitchedUser: cancelSwitchedUser,
        getRegistrationDetails: getRegistrationDetails,
        getSignupDetails: getSignupDetails,
        getResetPasswordUserDetails: getResetPasswordUserDetails,
        signupUser: signupUser,
        identificationSignupUser: identificationSignupUser,
        confirmIdentity: confirmIdentity,
        verifyCustomer: verifyCustomer,
        getAnonymousProtectBuyData: getAnonymousProtectBuyData,
        fetchKycModel: fetchKycModel,
        getAnonymousKycData: getAnonymousKycData,
        updateKycData: updateKycData,
        completeKycData: completeKycData,
        fetchKycCaptures: fetchKycCaptures,
        fetchKycCaptureData: fetchKycCaptureData,
        changeKycCaptureStatus: changeKycCaptureStatus,
        confirmAdvertising: confirmAdvertising,
        verifyNewsletter: verifyNewsletter,
        completeSignup: completeSignup,
        completeRegistration: completeRegistration,
        registerUser: registerUser,
        resetPassword: resetPassword,
        changePassword: changePassword,
        getEmail: getEmail,
        getEmails: getEmails,
        getActivities: getActivities,
        getPhonenumbers: getPhonenumbers,
        sendVerificationToPhone: sendVerificationToPhone,
        sendProtectBuyVerificationToPhone: sendProtectBuyVerificationToPhone,
        sendProtectBuyVerificationToPhoneAnonymous: sendProtectBuyVerificationToPhoneAnonymous,
        doVerifyProtectBuy: doVerifyProtectBuy,
        doSendMessengerActivationLink: doSendMessengerActivationLink,
        doVerifyPhone: doVerifyPhone,
        doVerifyPhoneAnonymous: doVerifyPhoneAnonymous,
        deactivatePhone: deactivatePhone,
        removePhone: removePhone,
        changeEmail: changeEmail,
        resendEmailVerification: resendEmailVerification,
        cancelEmailChange: cancelEmailChange,
        completeEmailChange: completeEmailChange,
        hasSsms: hasSsms,
        hasProtectBuy: hasProtectBuy,
        hasFeature: hasFeature,
        resendEmail: resendEmail,
        trackActivity: trackActivity,
        addContractVerification: addContractVerification,
        getRoleFields: getRoleFields,
        getUserFields: getUserFields
      };
    }]).name;


// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/UserService.js